import React, { useState } from "react";
import logo from "../assets/logo1.png";
import { useSelector, useDispatch } from "react-redux";
import { toggleHamburger, closeHamburger } from "../redux/slice/hamburgerSlice";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

export const NavLinks = () => {
  const isOpen = useSelector((state) => state.hamburger.isOpen);
  const [aboutusNavigated, setAboutusNavigated] = useState(false);
   const [isScrolled, setIsScrolled] = useState(false);
   
  const dispatch = useDispatch();
  const navLinks = [
    { name: "Home", path: "/", id: "home" },
    { name: "Events", path: "#", id: "events" },
    { name: "Ministries", path: "#", id: "ministries" },
    { name: "Services", path: "#", id: "services" },
    { name: "Outreach & Healing", path: "#", id: "outreach" },
    { name: "Meet our Pastors", path: "#", id: "pastors" },
    { name: "About Us", path: "/about" },
  ];
  const location = useLocation();
  const [filteredLinks, setFilteredLinks] = React.useState(navLinks);
  React.useEffect(() => {
    console.log("Current path:", location.pathname);
    if (location.pathname === "/about") {
      setAboutusNavigated(true);
      setFilteredLinks(navLinks.slice(1, navLinks.length - 1));
      console.log("Hash:", location.hash);
      if (location.hash) {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth" });
          }, 100); // slight delay to ensure element is mounted
        }
      }
    } else {
      setAboutusNavigated(false);
      setFilteredLinks(navLinks);
    }
  }, [location]);
 

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav
      className={`navbar custom-navbar is-transparent is-spaced sticky-navbar ${
        isScrolled ? "nav-shadow" : ""
      }`}
      role="navigation"
      aria-label="main navigation"
    >
      <div className="navbar-brand">
        <Link className="navbar-item " to="/" style={{ marginLeft: "-2rem" }}>
          <img src={logo} alt="AC Logo" width="100px" height="150px" />
        </Link>

        <a
          role="button"
          className={`navbar-burger ${isOpen ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded={isOpen ? "true" : "false"}
          onClick={() => dispatch(toggleHamburger())}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      {/* Custom Overlay Menu */}
      <div className={`overlay-menu ${isOpen ? "open" : ""}`}>
        <div className="overlay-content">
          {aboutusNavigated && (
            <Link to={`/`} className="overlay-item" onClick={() => dispatch(toggleHamburger())}>
              Home
            </Link>
          )}
          {filteredLinks.slice(0, navLinks.length - 1).map((link, index) =>
            location.pathname === "/" ? (
              <ScrollLink
                key={index}
                className="overlay-item"
                to={link?.id}
                smooth={true}
                duration={500}
                onClick={() => dispatch(closeHamburger())}
              >
                {link.name}
              </ScrollLink>
            ) : (
              <Link
                key={index}
                className="overlay-item"
                to={`/#${link?.id}`}
                onClick={() => dispatch(closeHamburger())}
              >
                {link.name}
              </Link>
            )
          )}

          <Link to={`/about`} className="overlay-item" onClick={() => dispatch(toggleHamburger())}>
            About Us
          </Link>
          <div className="overlay-button">
            <a
              className="button is-info is-rounded"
              href="#"
              onClick={() => dispatch(closeHamburger())}
            >
              Start Here
            </a>
          </div>
        </div>
      </div>
      {/* <Outlet />  */}
    </nav>
  );
};
